'use client';
import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import { useRouter } from 'next/navigation';
import { useLocale } from 'next-intl';
import styled from 'styled-components';

import { LOCALE_TO_LANGUAGE } from '@/i18n';
import Image from '@/ui/components/Image';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.62rem;

  img {
    display: block;
  }
`;

const FlagItem = styled.div`
  cursor: pointer;
`;

type FlagItem = {
  locale: string;
  link: string;
};

interface FlagsProps {
  items: FlagItem[];
}

export default function Flags({ items }: FlagsProps) {
  const router = useRouter();
  const currentLocale = useLocale();

  const handleLocaleChange = React.useCallback(
    (newLocale, link) => {
      router.push(link);

      // Refresh to update the useTranslation contexts
      if (typeof router.refresh === 'function') {
        router.refresh();
      }
    },
    [router, currentLocale]
  );

  return (
    <Wrapper>
      {items.map(({ locale, link }) => {
        return (
          <FlagItem
            key={locale}
            onClick={() => handleLocaleChange(locale, link)}
            tabIndex={0}
            role="button"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleLocaleChange(locale, link);
              }
            }}
          >
            <Tooltip
              title={LOCALE_TO_LANGUAGE[locale]}
              placement="bottom"
              arrow
            >
              <div>
                <Image
                  src={`/visuals/images/flags/${locale}.png`}
                  alt={LOCALE_TO_LANGUAGE[locale]}
                  width={32}
                  height={21}
                />
              </div>
            </Tooltip>
          </FlagItem>
        );
      })}
    </Wrapper>
  );
}
